const getters = {
  // roleId: state => state.user.roleId,
  classList: state => state.classInfo.classList,
}
export default getters
